import { render, staticRenderFns } from "./NewsListItem.vue?vue&type=template&id=92613ed4&scoped=true"
import script from "./NewsListItem.vue?vue&type=script&lang=js"
export * from "./NewsListItem.vue?vue&type=script&lang=js"
import style0 from "./NewsListItem.vue?vue&type=style&index=0&id=92613ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92613ed4",
  null
  
)

export default component.exports